<template>
    <div>
        <h2>Itens de Almoxarifado</h2>
        <div class="d-flex w-100 gap-10 search-form">
            <form class="w-100 flex-grow-1 d-flex" @change="getItensOs">
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            class="pt-5 pb-5"
                            chips
                            v-model="search"
                            clearable
                            hide-details
                            hide-selected
                            prepend-icon="mdi-magnify"
                            label="Search"
                            solo
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            class="pt-5 pb-5"
                            chips
                            v-model="itemCodigo"
                            clearable
                            hide-details
                            hide-selected
                            label="Código do Item"
                            solo
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            class="pt-5 pb-5"
                            chips
                            v-model="osSearch"
                            clearable
                            hide-details
                            hide-selected
                            label="OS"
                            solo
                        />
                    </v-col>
                </v-row>
            </form>

            <div class="text-center">
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="primary"
                            v-on="on" 
                            large
                            :disabled="selected.length == 0"
                        >
                            Ações em Massa...
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="(item, index) in actionsMassa"
                            :key="index"
                            :value="index"
                            @click="item.handle"
                            class="cursor-pointer"
                        >
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-menu>
            </div>
        </div>
        
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            class="elevation-1 mt-10 header-table text-no-wrap"
            disable-sort
            hide-default-footer
            :page.sync="page"
            item-value="name"
            show-select            
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            return-object
        >
        
            <template v-slot:[`item.ordemDeServico`]="{ item }">
                <span>
                    {{ item.ordemDeServico[0]?.codigo || "Não Informado" }}
                </span>
            </template>
            <template v-slot:[`item.job`]="{ item }">
                <span>
                    {{ item.ordemDeServico[0]?.jobCodigo || "Não Informado" }}
                </span>
            </template>
            <template v-slot:[`item.quantidade`]="{item}">
                <span>
                    {{ item.quantidade || 0 }}
                </span>
            </template>
            <template v-slot:[`item.quantidadeDisponivel`]="{ item }">
                <span>
                    {{ item.item?.saldoDeEstoque?.quantidadeDisponivel || 0 }}
                </span>
            </template>
            <template v-slot:[`item.dataNecessidade`]="{ item }">
                <span>
                    {{ new Date(item.dataNecessidade).toLocaleDateString() }}
                </span>
            </template>
        </v-data-table>
        
        <div class="text-center pt-2">
            <v-pagination
                v-model="page"
                :length="pageCount"
                @input="pagination"
            ></v-pagination>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import EntityService from "@/services/entityService.js";
import { name } from '@azure/msal-browser/dist/packageMetadata';

export default {
    name: 'ItensWarehouse',
    data() {
        return {
            search: '',
            osSearch: '',
            itemCodigo: '',
            selected: [],
            entityService: new EntityService('OrdemDeServicoItens'),
            entityServiceItem: new EntityService('Item'),
            entityServiceItemProdutoAcabado: new EntityService('ItensProdutoAcabado'),
            items: [],
            page: 1,
            pageCount: 0,
            itemsPerPage: 0,
            headers: [
                { text: "JOB", value: "job" },
                { text: "OS", value: "ordemDeServico" },
                { text: "Seq", value: "sequencia" },
                { text: "Material", value: "itemCodigo" },
                { text: "Descrição", value: "descricao" },
                { text: "Unidade", value: "unidadeSigla" },
                { text: "Quantidade Solicitada", value: "quantidade" },
                { text: "Quantidade Disponivel", value: "quantidadeDisponivel" },
                { text: "Status", value: "status" },
                { text: "Prazo Desejado", value: "dataNecessidade"}
            ],
            actionsMassa: [
                { 
                    title: 'Enviar para Fabricação (SF)',
                    handle: () => {
                        this.sendSF()
                    }
                },
                { 
                    title: 'Enviar para Compras (SC)', 
                    handle: () => {
                        this.sendSC()
                    }
                },
                {
                    title: 'Reservar (RE)',
                    handle: () => {
                        this.sendRE()
                    }
                }
            ]
        }
    },

    methods: {
        async getItensOs(){
            let response = await Vue.prototype.$http.post('/View/run', {
                "params": [
                    { dataType: "string", name: "descricao", value: this.search, },
                    { dataType: "string", name: "codigoOs", value: this.osSearch },
                    { dataType: "itemCodigo", name: 'itemCodigo', value: this.itemCodigo }
                ],
                "viewId": "9038198d-674a-4f8a-93e2-941760bf17a7",
                "page": this.page,
                "limit": 30
            });

            this.items = response.data.data.data?.filter((itemRes) => itemRes.ordemDeServico.length > 0)
            this.pageCount = response.data.data.pages
            this.itemsPerPage = response.data.data.limit
        },

        async sendSF(){

            let newsOs = []
            let itensOrdemFabricacao = []
            //let itensSendSC = []

            const user = await this.$auth.getUserParams();

            // itensSendSC = this.selected.filter((select) => select?.item?.saldoDeEstoque?.quantidadeDisponivel || 0 < select?.quantidade)

            // const ids = this.selected.filter((select) => select?.item?.saldoDeEstoque?.quantidadeDisponivel || 0 >= select.quantidade).map((itemSelected) => {
            //     return itemSelected.item.id
            // }).join(',')

            const ids = this.selected.map((itemSelected) => {
                return itemSelected.item.id
            }).join(',')

            let osItems = []
            if(ids){
                const response = await this.entityServiceItem.getAll(1, 1000, null, null, ids, null, null)
                osItems = response.data.data.data
            }

            //console.log('response ITEM >>> ', osItems)

            for (const [index, osItem] of osItems?.entries()) {
                const osMae = this.selected[index].ordemDeServico[0]
                const osSlected = this.selected[index]
                // console.log('osMae ', osMae.itens.filter((os) => os == this.selected[index].id))

                if(osItem?.itens?.length > 0) {
                    console.log('osItem >>> ', osItem)

                    const idsItens = osItem.itens.map((item) => {
                        return item
                    }).join(',')

                    const responseItensProdutoAcabado = await this.entityServiceItemProdutoAcabado.getAll(1, 1000, null, null, idsItens, null, null)
                    const itensProdutoAcabado = responseItensProdutoAcabado.data.data.data

                    //console.log('itensProdutoAcabado >>> ', itensProdutoAcabado)

                    let osProdutoAcabado = []
                    let itensServicoResponse = []

                    itensProdutoAcabado.forEach(async (produtoAcabado, index) => {

                        osProdutoAcabado.push({
                            sequencia: index + 1,
                            item: produtoAcabado.item,
                            quantidade: produtoAcabado.quantidade,
                            descricao: produtoAcabado?.itemDescricao,
                            status: 'LA',
                            destino: 'ND',
                            dataSolicitacao: new Date(),
                        })
                        
                        itensOrdemFabricacao.push({
                            seq: index + 1,
                            qty: produtoAcabado.quantidade,
                            itemId: produtoAcabado.item,
                            itemOrdemDeServico: osItem.id
                            //descricao: produtoAcabado?.descricao
                        })
                        
                    })

                    console.log('osProdutoAcabado >>> ', osProdutoAcabado.sort((a, b) => parseInt(a.sequencia) - parseInt(b.sequencia)))
                    const response = await Vue.prototype.$http.post('/Entity/insertMany/OrdemDeServicoItens', osProdutoAcabado.sort((a, b) => parseInt(a.sequencia) - parseInt(b.sequencia)));
                    itensServicoResponse = response.data.data
                    console.log('itensServicoResponse >>> ', response.data.data.sort((a, b) => parseInt(a.sequencia) - parseInt(b.sequencia)))
                    
                    newsOs.push({
                        osMae: osMae?._id,
                        job: osMae?.job,
                        coordenadorDeProjetos: osMae?.coordenadorDeProjetos,
                        osTipo: "Fabricação",
                        valorDisponivel: osMae?.valorDisponivel,
                        dataEncerramentoPrevista: osMae?.dataEncerramentoPrevista,
                        dataEncerramento: osMae?.dataEncerramento,
                        itens: itensServicoResponse.sort((a, b) => parseInt(a.sequencia) - parseInt(b.sequencia))?.map((item) => {
                            return item.id
                        }),
                        dataSolicitacao: new Date().toDateString(),
                        itemOrdemDeServico: osItem.id,
                        descricao: osItem.description,
                        osQuantidade: osMae?.osQuantidade,
                        classificacaoContabil: osItem.classificacao,
                        owners: [user.userId]
                    })

                } else {

                    itensOrdemFabricacao.push({
                        seq: index + 1,
                        qty: osMae?.osQuantidade,
                        itemId: osItem.id,
                        itemOrdemDeServico: osItem.id
                        //descricao: osItem.description
                    })

                    newsOs.push({
                        osMae: osMae?._id,
                        job: osMae?.job,
                        coordenadorDeProjetos: osMae?.coordenadorDeProjetos,
                        osTipo: "Fabricação",
                        valorDisponivel: osMae?.valorDisponivel,
                        dataEncerramentoPrevista: osMae?.dataEncerramentoPrevista,
                        dataEncerramento: osMae?.dataEncerramento,
                        osQuantidade: osMae?.osQuantidade,
                        itens: [],
                        dataSolicitacao: new Date().toDateString(),
                        itemOrdemDeServico: osItem.id,
                        descricao: osItem.description,
                        classificacaoContabil: osItem.classificacao,
                        owners: [user.userId]
                    })
                }
            }

            if(newsOs.length > 0){
                const responsePostMany = await Vue.prototype.$http.post('/Entity/insertMany/OrdemDeServico', newsOs);

                const ordemFabricacao = responsePostMany.data.data.map((os, index) => {
                    itensOrdemFabricacao.map((fab) => {
                        fab.osFilha = os.codigo
                    })

                    return {
                        status: 'Pendente',
                        job: os.jobCodigo,
                        solicitante: 'Almoxarifado',
                        os: os.osMaeCodigo,
                        cliente: '',
                        produto: os.descricao
                    }
                })

                const responseItensOrdemFabricacao = await Vue.prototype.$http.post('/Entity/insertMany/ItensOrdemDeFabricacao', itensOrdemFabricacao);
                const itensOrdem = responseItensOrdemFabricacao.data.data
                ordemFabricacao.map((orderFab, index) => {
                    orderFab.itens = []
                    const itemOSId = newsOs[index].itemOrdemDeServico;
                    orderFab.osItem = this.selected[index].id

                    orderFab.itens = itensOrdem
                        .filter(item => item.itemOrdemDeServico === itemOSId)
                        .map(item => item.id);

                })

                console.log('ordemFabricacao >>> ', ordemFabricacao)

                await Vue.prototype.$http.post('/Entity/insertMany/OrdemDeFabricacao', ordemFabricacao);

                if(responsePostMany.data.success){
                    this.changeStatus("SF", this.selected)
                    await this.sendAlert("SF", "70e6be18-e95a-4201-8d7f-d61a7af271da", 'Realizaer liberação de OS filha (fabricação)') // Gabriel Marcos de Rosa Miari
                    //this.$notfy.success(`Items enviados para SF.`);
                    this.selected = []
                } else {
                    this.$notfy.error("Erro ao atualizar os itens.");
                }

            }
/*
            if(itensSendSC.length > 0) {
                this.changeStatus("SC", itensSendSC)
                await this.sendAlert("SC", "065e2ba6-a8a1-4a74-a4ed-d6e2346b7545", 'Realizar a distribuição para compradores') // Fernando Antonio Rosatti
            }*/

        },

        async sendSC() {
            this.changeStatus("SC", this.selected)
            await this.sendAlert("SC", "065e2ba6-a8a1-4a74-a4ed-d6e2346b7545", 'Realizar a distribuição para compradores') // Fernando Antonio Rosatti
        },

        async sendRE(){

            if(this.selected.some((select) => (select?.item?.saldoDeEstoque?.quantidadeDisponivel || 0) < select?.quantidade)){
                this.$notfy.error("Não é possível reservar itens com quantidade disponível menor que a quantidade solicitada.")
                return
            }
            
            await Promise.allSettled([
                this.updateStockBalance(this.selected),
                this.changeStatus("RE", this.selected),
                this.sendAlert("RE", "70e6be18-e95a-4201-8d7f-d61a7af271da", 'Realizaer reserva de material'), // Gabriel Marcos de Rosa Miari
                this.sendAlert("RE", "065e2ba6-a8a1-4a74-a4ed-d6e2346b7545", 'Realizar a distribuição para compradores') // Fernando Antonio Rosatti
            ])
        },

        async updateStockBalance(itemsSelected){
            itemsSelected.map(async (item) => {

                const response = await Vue.prototype.$http.get(`/Entity/StockBalance/${item?.item?.saldoDeEstoque.id}`);

                delete response.data.data.createAt
                delete response.data.data.updatedAt
                delete response.data.data.updateBy
                delete response.data.data.createBy
                delete response.data.data.deleteAt
                delete response.data.data.deleteBy

                await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                    ...response.data.data,
                    quantidadeDisponivel: response.data.data.quantidadeDisponivel - item.quantidade
                })
            })
        },

        async changeStatus(status, itemsSelected){
            await this.saveHistoricChange(status)

            itemsSelected.map((item) => {

                delete item?.createAt
                delete item?.updatedAt
                delete item?.updateBy
                delete item?.createBy
                delete item?.updateBy
                delete item?.deleteAt
                delete item?.deleteBy
                delete item?.ordemDeServico

                item.item = item.item.id

                item.status = status

            })

            const response = await Vue.prototype.$http.put('/Entity/updateMany/OrdemDeServicoItens', itemsSelected);

            if(response.data.success){
                this.$notfy.success(`Items enviados para ${status}.`);
                this.getItensOs()

                this.selected = []

            } else {
                this.$notfy.error("Erro ao atualizar os itens.");
            }
        },

        async saveHistoricChange(status){
            let itemsPost = []

            const user = await this.$auth.getUserParams();

            this.selected.map((item) => {
                itemsPost.push({
                    novo_status: status,
                    itemId: item.item.id,
                    os: item?.ordemDeServico[0]?.codigo,
                    osItem: item.id,
                    date_change: new Date().toISOString().split("T")[0] + "T03:00:00Z",
                    time: new Date().toLocaleTimeString(),
                    user: user.user
                })
            })

            console.log('itemsPost >>> ', itemsPost)

            await Vue.prototype.$http.post('/Entity/insertMany/HistoricoMudancaStatus', itemsPost)
            
        },
        
        pagination(page) {
            this.page = page
            this.getItensOs()
        },

        async sendAlert(status, userId, description){
            await Vue.prototype.$http.post('/Entity/Alert',
                {
                    title: `Atenção, item de OS foi enviado para ${status}`,
                    description,
                    link: '',
                    view: 'Não',
                    //schemaRecordId: schemaRecordId,
                    user: userId
                },
            )
        }
    },

    async created(){
        await this.getItensOs()
    },

    watch: {
        selected(values){
            console.log('VALUES >>> ', values)
            // this.saveHistoricChange("RE")
        }
    }
}
</script>

<style scoped>
    .container {
        width: '100%'
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }
    .header-table thead tr {
        position: sticky;
        top: 0;
        right: 0;
        background-color: #fff;
    }

</style>